<template>
  <div>
    <legend>{{ legend }}
		<a @click="close" href="#" class="btn pull-right closeWindow">
			<i class="fas fa-times fa-2x"></i>
	  	</a>
	</legend>
  	<div class="group_header">
  		<div class="row">
  			<h2 class="col-md-10" style="margin-top: 0px">{{current.eventShortTitle}} - <span :style="'font-weight:bold; color :'+places.color">{{places.val}}</span></h2>
  			<button type="button" @click="$emit('edit-booking-multiple')" class="btn default btnCard col-md-2"><i class="fas fa-pencil-alt"></i></button>
  		</div>
  		<h4 v-if="sameDay(current.eventStart,current.eventEnd)">Le : {{current.eventStart | moment}}</h4>
  		<h4 v-else>Du : {{current.eventStart | moment }} au {{current.eventEnd | moment }}</h4>
  		<span v-if="bookingMultiple.comment" v-html="'<u>Remarque :</u> '+bookingMultiple.comment"></span>
  		<span v-if="current.meeting_point" v-html="'<u>RDV :</u> '+current.meeting_point"></span>
  	</div>
  	<form>
  		<div class="portlet light">
	        <div class="ss-titre">
	            <span class="font-red-sunglo uppercase bold">Groupe</span>
	        </div>
	        <div class="portlet-body">
			  	<table class="table">
			  		<thead>
			  			<tr>
			  				<th>Contact</th>
			  				<th>Tél</th>
			  				<th>E-Mail</th>
			  				<th>Nombre</th>
			  				<th>Commentaire</th>
			  				<th>Facturation</th>
			  				<th>Actions</th>
			  				<th></th><!--axios status-->
			  			</tr>
			  		</thead>
			  		<tbody>
			  			<tr v-if="bookingMultiple.groups.length<1">
			  				<td>Aucun groupe ajouté.</td>
			  			</tr>
			  			<!--using for in template to preserve index position while displaying only non-null element-->
			  			<template v-for="(group, index) in bookingMultiple.groups">
				  			<tr v-if="group!=null" :key="group.id">
				  				<td>{{group.contact.fullName}}</td>
				  				<td>{{group.contact.phone}}</td>
				  				<td>{{group.contact.email}}</td>
				  				<td>{{group.group_count}}</td>
				  				<td>{{group.comment}}</td>
				  				<td>
				  					{{group.customer.fullName}}
				  					<i data-toggle="tooltip" data-html="true" data-container="body" title="Facturé" v-if="group.is_bill" class="far fa-money-bill-alt" style="color: green"></i>
				  				</td>
				  				<td>
				  					<div class="btn-group">
		                                <button class="btn btn-xs btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
		                                    Actions
		                                    <i class="fa fa-angle-down"></i>
		                                </button>
		                                <ul class="dropdown-menu pull-right" role="menu">
		                                	<li>
		                                		<a :href="redirectbillingroute.toString()+'/create?bmgid='+group.id">
		                                			<i class="far fa-money-bill-alt" style="color: green"></i><span>&nbsp;Facturer</span>
												</a>
											</li>
		                                    <li :class='showCustoForm?"disabled":""' :title="showCustoForm?`Veuillez valider ou annuler la modification en cours avant de modifier un nouveau groupe.`:''">
		                                    	<a @click="editGroup(index)">
		                                    		<i class="fas fa-pencil-alt"></i><span>&nbsp;Modifier</span>
		                                    	</a>
		                                    </li>
		                                    <li class="divider"></li>
		                                    <li>
		                                		<a @click="removeGroup(index)">
		                                			<i class="fa fa-trash" style="color: rgba(255, 0, 0, 0.575)"></i><span>&nbsp;Supprimer</span>
												</a>
											</li>
		                                </ul>
		                            </div>
				  				</td>
				  				<td v-show="group.statusClass"><i :class="group.statusClass"></i></td>
				  			</tr>
			  			</template>
			  		</tbody>
			  	</table>
			  	<button v-show="!showCustoForm" type="button" class="btn btn-primary" @click="showCustoForm=true">Ajouter un client</button>
			  	<div v-show="showCustoForm" class="form-group">
					<customer-select v-model="group_selected.contact" selectLabel="Contact *" btnLabel="Nouveau contact" @input="contactInput" v-validate="'required'" data-vv-name="Contact"></customer-select>
					<customer-select v-model="group_selected.customer" selectLabel="Client à facturer *" v-validate="'required'" data-vv-name="Client à facturer"></customer-select>
					<div class="row">
						<div class="col-md-12">
							<label>Commentaire :</label>
							<textarea title="Commentaire" class="form-control" v-model="group_selected.comment" v-validate="'max:2000'" data-vv-name="Commentaire"></textarea>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<label>Modalité de paiement:</label>
							<div class="form-inline">
							    <select class="form-control input-medium" name="typePaiement" v-model="group_selected.payment_method">
							    	<option  v-for="payment in payments" :value="payment" :key="payment.index">{{ payment }}</option>
							    </select>
							    <select class="form-control input-medium" name="statusPaiement" v-model="group_selected.is_paid">
							      	<option :value="1">Payé</option>
							      	<option :value="0">Non payé</option>
							    </select>
						     	<i v-show="group_selected.is_paid" class="far fa-smile fa-lg" style="color: green; margin-left: 1rem"></i>
						      	<i v-show="!group_selected.is_paid" class="far fa-frown fa-lg" style="color: red; margin-left: 1rem"></i>
							 </div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<label>Nombre *:</label>
							<input class="form-control" v-model="group_selected.group_count" v-validate="'required|integer|min_value:1'" data-vv-name="Nombre">
						</div>
						<div class="col-md-3">
							<button type="button" class="btn btn-danger btn-block btn-inline" @click="cancelAddGroup">Annuler</button>
						</div>
						<div class="col-md-3">
							<button type="button" class="btn green btn-block btn-inline" @click="addGroup">Valider</button>
						</div>
					</div>
					<div class="alert alert-danger"  v-show="ferrors.all().length>0">
						<h3>{{errorsTitle}}</h3><hr>
						<ul>
							<li v-for="error in ferrors.all()" :key="error.id">{{ error }}</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="portlet light">
	        <div class="ss-titre">
	            <span class="font-red-sunglo uppercase bold">Encadrement</span>
	        </div>
	        <div class="portlet-body form-group">
			  	<div class="row">
			  		<div class="col-md-4">
					  	<table class="table">
					  		<thead>
					  			<tr>
					  				<th style="padding-top: 0px">Encadrant(s)</th>
					  				<th></th><!--remove button-->
					  				<th></th><!--axios status-->
					  			</tr>
					  		</thead>
					  		<tbody>
					  			<tr v-if="booking_encs.length<1">
					  				<td>Aucun encadrant ajouté.</td>
					  			</tr>
					  			<!--using for in template to preserve index position while displaying only non-null element-->
					  			<template v-for="(enc, index) in booking_encs">
					  				<tr v-if="enc!=null" :key="enc.fullName">
						  				<td>{{enc.fullName}}</td>
						  				<td>
						  					<button type="button" class="btn btn-danger btnCard" @click="removeEnc(index)" :disabled="enc.statusClass==statusClass.loading || enc.statusClass==statusClass.failure">
						  						<i class="fa fa-trash"></i>
						  					</button>
						  				</td>
	  									<td v-show="enc.statusClass"><i :class="enc.statusClass"></i></td>
						  			</tr>
					  			</template>
					  		</tbody>
					  	</table>
				  	</div>
			  		<div class="col-md-5">
			  			<label for="enc_selection">Encadrant *:</label>
				  		<select class="form-control" v-model="enc_selected" id="enc_selection">
							<option v-for="enc in encsList" :value="enc" :key="enc.fullName">{{ enc.fullName }}</option>
						</select>
						<div v-show="encAlreadyAdded" class="alert alert-danger">Cet encadrant est déjà ajouté.</div>
					</div>
					<div class="col-md-3">
						<button type="button" @click="addEnc" class="btn green btn-block btn-inline">Valider</button>
					</div>
			  	</div>
		  	</div>
	  	</div>
	  	<button type="button" class="btn green btn-block" @click="close">Terminer</button>
  	</form>
  </div>
</template>
<script>
import vSelect from 'vue-select';

export default {
	name: 'calBookingMultipleGroup',
	props: ['current','booking','users','renforts','quickCreate','legend','redirectbillingroute'],
	components: {
      'v-select-lib': vSelect
    },
	data() {
		return {
			bookingMultiple:Object.assign({},this.booking),
			encsList:this.users.concat(this.renforts),
			enc_selected:{},
			group_selected:{is_paid: false},
			group_previous:{},//store previous state of group and its index to restaure if editing is canceled
			booking_encs:this.getBookingEncs(),
			payments: ['','Chèque ou Virement','Chèque', 'Espèce', 'Virement', 'CB', 'CB en ligne', 'Offert', 'Chèque vacances', 'Bon cadeau', 'Autre'],
			showCustoForm:false,
			hasChanged:false,//If some data have been updated, refresh events when closing component.
			groupRoute:'calendar/event/bookingmultiplegroup/',
			groupErrors:[],
			encAlreadyAdded:false,
			statusClass:{loading:"fas fa-spinner",success:"fas fa-check",failure:"statusError fas fa-times"}
		}
	},
	mounted: function(){
		$('[data-toggle="tooltip"]').tooltip();
	},

        filters: {
                moment: function (date) {
                return moment(date).format('DD/MM/YYYY');
            }
        },

	computed:{
		places:function(){
			let count = this.$parent.$refs.calendar.participantsCount(this.bookingMultiple.groups)
			return {
				"val":count+"/"+this.bookingMultiple.total_places,
				"color":count>this.bookingMultiple.total_places?'#99371a':count<this.bookingMultiple.total_places?'green':'#c98570'
			}
		},
		errorsTitle(){
			let plural = (this.ferrors.all().length<2)?'':'s'
			return 'Erreur'+plural+' lors de la validation :';
		}
	},
	methods: {
		sameDay(date1, date2){

			return moment(this.current.eventStart).isSame(this.current.eventEnd, 'day');
		},
		getBookingEncs(){
			let users=this.users.filter(function(user){
				return this.current.usersIds.includes(user.id)
			}.bind(this))
			let renforts = this.renforts.filter(function(renfort){
				return this.current.renfortsIds.includes(renfort.id)
			}.bind(this))
			return users.concat(renforts)
		},
		contactInput(value){
			if((!this.group_selected.customer || Object.keys(this.group_selected.customer).length === 0) && value){
				this.group_selected.customer=value
				if(this.groupErrors.length){//prevent error display when entering value for first time
				//use to update contact/customer when added with customer creation modal
					this.$nextTick(function () {//doesn't work with only one nextTick
						this.$nextTick(function () {
							this.validateGroup()//update customer validation
						})
					})
				}
			}
		},
		addEnc(event){
			if(Object.keys(this.enc_selected).length !== 0){
				this.encAlreadyAdded=_.map(this.booking_encs,'id').includes(this.enc_selected.id)
				if(!this.encAlreadyAdded){//check if user has already been added to the encadrants list
					this.enc_selected.statusClass=this.statusClass.loading
					let index = this.booking_encs.push(this.enc_selected)-1
					const route = this.groupRoute + this.bookingMultiple.id+'/enc';
					let vm=this
					axios.put(route,this.enc_selected)
						.then(response => {//TODO : check success
							vm.hasChanged=true;
							vm.booking_encs[index].statusClass=vm.statusClass.success
							vm.booking_encs=Object.assign([],vm.booking_encs);//object assign to force render update
							setTimeout(function(){
								if(vm.booking_encs[index]){//if still exist (not deleted during timeout)
									vm.booking_encs[index].statusClass=''
									vm.booking_encs=Object.assign([],vm.booking_encs);//object assign to force render update
								}
							}, 5000);
						}).catch(function(error){
							vm.$snotify.error(error.response.statusText,'Erreur '+error.response.status,{timeout:5000})
							vm.booking_encs[index].statusClass=vm.statusClass.failure
				    		vm.booking_encs=Object.assign([],vm.booking_encs);//object assign to force render update
						})
					this.enc_selected={}
				}
			}
		},
		removeEnc(index){
			this.encAlreadyAdded=false
			this.booking_encs[index].statusClass=this.statusClass.loading
			this.booking_encs=Object.assign([],this.booking_encs);//object assign to force render update

			const route = this.groupRoute + this.bookingMultiple.id+'/enc';
			let vm = this
			axios.delete(route,{data:this.booking_encs[index]})
				.then(response => {
					if(response.data.deleted>0){//if enc is deleted
						vm.hasChanged=true;
						vm.$set(vm.booking_encs, index, null)//set to null to preserve index
						/* Without index preservation :
						 * If there is 4 groups (index 0-3) :
						 * ->deletion of index 2 is trigger
						 * ->update of index 3 is trigger
						 * ->deletion of index 2 complete
						 *		-> index 2 removed
						 *		-> index 3 became index 2
						 *	->update of index 3 complete
						 *	->there is no more index 3 because index 3 become index 2*/
					}
				}).catch(function(error){
					vm.$snotify.error(error.response.statusText,'Erreur '+error.response.status,{timeout:5000})
					vm.booking_encs[index].statusClass=vm.statusClass.failure
			    	vm.booking_encs=Object.assign([],vm.booking_encs);//object assign to force render update
				})
		},
	    async addGroup(){
	    	this.group_previous={}
			let isValid = await this.validateGroup();
	    	if(isValid){
		    	this.group_selected.booking_multiple_id =this.bookingMultiple.id
		    	this.group_selected.statusClass=this.statusClass.loading;
		    	this.showCustoForm=false
		    	let index = this.bookingMultiple.groups.push(this.group_selected)-1
				const route = this.groupRoute + this.bookingMultiple.id+'/group';
				let vm = this
				axios.put(route,this.group_selected)
					.then(response => {
						vm.bookingMultiple.groups[index].id=response.data.id
						vm.hasChanged=true;
		    			vm.bookingMultiple.groups[index].statusClass=vm.statusClass.success;
		    			setTimeout(function(){
		    				vm.bookingMultiple.groups[index].statusClass=''
		    				vm.bookingMultiple=Object.assign({},vm.bookingMultiple);//object assign to force render update
		    			}, 5000);
						vm.group_selected={is_paid:false}//clear form
						//vm.contactsList=[]//clear contact/customer suggestion when addGroup
						//vm.customersList=[]
					}).catch(function(error){
						vm.bookingMultiple.groups[index].statusClass=vm.statusClass.failure
			    		vm.bookingMultiple=Object.assign({},vm.bookingMultiple);//object assign to force render update
						let errorData = error.response.data
						if(errorData.errors){//request validation error
							for(let field in errorData.errors){
								for(let fieldError of errorData.errors[field]){
									vm.$snotify.error(fieldError,'Erreur : ',{timeout:5000})
								}
							}
						}else{//HTTP Status Codes
							vm.$snotify.error(error.response.statusText,'Erreur '+error.response.status,{timeout:5000})
						}
					})
			}
	    },
	    cancelAddGroup(){
	    	this.group_selected={is_paid:false}//clear form
	    	this.showCustoForm=false
	    	//this.contactsList=[]//clear contact/customer suggestion when addGroup
	    	//this.customersList=[]
	    	if(!_.isEmpty(this.group_previous)){//put back currently editing group to previous index
		    	this.bookingMultiple.groups[this.group_previous.index]=this.group_previous.group
		    	this.group_previous={}
	    	}
	    },
	    editGroup(index){
	    	if(!this.showCustoForm){//when currently editing/creating a group prevent new edit
	    		this.group_previous.group = _.cloneDeep(this.bookingMultiple.groups[index])
	    		this.group_previous.index = index
	    		this.group_selected = this.bookingMultiple.groups[index]
	    		this.bookingMultiple.groups.splice(index,1)
	    		this.showCustoForm=true
	    	}
	    },
	    removeGroup(index){
	    	this.bookingMultiple.groups[index].statusClass=this.statusClass.loading
	    	this.bookingMultiple=Object.assign([],this.bookingMultiple);//object assign to force render update
	    	let vm = this
	    	const route = this.groupRoute+'group/' + this.bookingMultiple.groups[index].id;
			axios.delete(route).then(response => {
				if(response.data.deleted==1){
					vm.bookingMultiple.groups[index]= null
		    		vm.bookingMultiple=Object.assign([],vm.bookingMultiple);//object assign to force render update
					vm.hasChanged=true
				}else{
					vm.$snotify.error('Une erreur est survenue lors de la suppression du groupe.','Erreur',{timeout:5000})
				}
			}).catch(function(error){
				vm.$snotify.error(error.response.statusText,'Erreur '+error.response.status,{timeout:5000})
				vm.bookingMultiple.groups[index].statusClass=vm.statusClass.failure
		    	vm.bookingMultiple=Object.assign([],vm.bookingMultiple);//object assign to force render update
			})
	    },
		async validateGroup(){
			let errorsCount = 0
			let vm = this;
			await this.$validator.validateAll().then((result) =>{
			    errorsCount=vm.ferrors.all().length
			});
			return errorsCount==0
		},
		close(){
			this.$emit('close')
			if(this.hasChanged){
				this.$emit('refetch-events')
				this.$emit('snotify')
			}
		}
	}
}
</script>
<style type="text/css" scoped>
	.group_header>.row>h1{
		margin-top: 0px;
	}
	.btn-inline{
		margin-top: 2.5rem;
	}
	.portlet{
		padding:0px !important;
	}
	.fa-spinner {
		color: #114753;
	  	animation: spin 2s linear infinite;
	}
	.fa-check {
		color: green;
	}
	.statusError {
		color: red;
	}

	@keyframes spin {
	  0% { transform: rotate(0deg); }
	  100% { transform: rotate(360deg); }
	}
</style>